var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
/* eslint-disable react/hook-use-state -- WIP*/
/* eslint-disable react-hooks/exhaustive-deps -- WIP*/
/* eslint-disable @typescript-eslint/no-unsafe-return -- WIP*/
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- WIP*/
import { dequal } from 'dequal';
import { useCallback, useMemo, useState } from 'react';
import { useBeforeFirstRender, useIsMounted, useMemoExtended, useUpdate, useUpdatedRef, } from '../../../custom-hooks';
import { useFormRoot } from '../../../providers';
/**
 * We set that the formatter
 * should only be dependent
 * on the dependency value.
 * So it will be called only
 * when the dependency value
 * gets updated.
 */
export const useFieldState = ({ dependencyExtractor, disabled, fieldId, formatter, initialValue, }) => {
    _react_refresh_temp_1();
    const { fieldsToBeSet, formData, injectedErrors, isUsingStorage, methods: { setDirty, setFieldsValue },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Intentional
     } = useFormRoot();
    const dependency = useMemo(() => {
        if (typeof dependencyExtractor === 'function' && Boolean(formData)) {
            return dependencyExtractor(formData);
        }
        else {
            return undefined;
        }
    }, [dependencyExtractor, formData]);
    const updatedDependency = useMemoExtended(() => dependency, [dependency], true);
    const isBuiltDisabled = useMemo(() => Boolean(typeof disabled === 'function'
        ? disabled(updatedDependency)
        : disabled), [updatedDependency, disabled]);
    const updatedDependencyRef = useUpdatedRef(updatedDependency);
    const formatterRef = useUpdatedRef(formatter);
    const builtInitialValue = useMemo(() => {
        let value;
        if (typeof initialValue === 'function') {
            // TODO: Think of a way to ensure that this function returns type T
            value = initialValue(updatedDependency);
        }
        else {
            value = initialValue;
        }
        return value;
    }, [updatedDependency, initialValue]);
    const updatedInitialValue = useMemoExtended(() => builtInitialValue, [builtInitialValue], true);
    let initialStateValue = updatedInitialValue;
    useBeforeFirstRender(() => {
        if (formatter) {
            initialStateValue = formatter({
                dependencyValue: updatedDependency,
                newValue: updatedInitialValue,
            });
        }
        else {
            initialStateValue = updatedInitialValue;
        }
    });
    const [state, setFieldState] = useState({
        errors: [],
        isFocused: false,
        isTouched: false,
        isValid: true,
        isValidating: false,
        value: initialStateValue,
    });
    const isMounted = useIsMounted();
    const setState = useCallback((value) => {
        if (isMounted.current) {
            setFieldState(value);
        }
    }, [isMounted]);
    const blur = useCallback(() => {
        setState((current) => ({
            ...current,
            isFocused: false,
            isTouched: true,
        }));
    }, []);
    const focus = useCallback(() => {
        setState((current) => ({
            ...current,
            isFocused: true,
            isTouched: true,
        }));
    }, []);
    const setTouch = useCallback((isTouched) => {
        setState((current) => ({ ...current, isTouched }));
    }, []);
    const setValidity = useCallback(({ errors, isValid }, validated) => {
        setState((current) => {
            // Drop an incoming validation result if it's not for the current value and dependency
            if (!dequal(current.value, validated.value) ||
                !dequal(updatedDependencyRef.current, validated.dependencyValue)) {
                return current;
            }
            return {
                ...current,
                errors,
                isValid,
                isValidating: false,
            };
        });
    }, []);
    const setValue = useCallback(({ value }, force) => {
        setState((current) => {
            const formattedValue = formatterRef.current
                ? formatterRef.current({
                    dependencyValue: updatedDependencyRef.current,
                    newValue: value,
                    oldValue: current.value,
                })
                : value;
            // Allow arrays as field values:
            const hasNewValue = !dequal(current.value, formattedValue);
            if (hasNewValue || force) {
                return {
                    ...current,
                    isValid: false,
                    isValidating: true,
                    value: formattedValue,
                };
            }
            else {
                return current;
            }
        });
    }, []);
    const resetState = useCallback((value) => {
        setState((current) => ({
            ...current,
            isFocused: false,
            isTouched: false,
            isValid: false,
            isValidating: true,
            value,
        }));
    }, []);
    const triggerValidation = useCallback(() => {
        setState((current) => ({
            ...current,
            isValidating: true,
        }));
    }, []);
    // Sync with storage or with
    // the internal state on
    // dependency update:
    useUpdate(() => {
        setValue({ value: isUsingStorage ? updatedInitialValue : state.value }, true);
    }, [updatedDependency]);
    useUpdate(() => {
        // When outside storage is being used
        // and we update through user action
        // the user action calls onChangeHandler
        // with one value, but while a new value
        // is ready for set up, the storage
        // updates the initialValue but to the
        // previously set value, and a flicker
        // occurs (infinite loop is started):
        if (!isUsingStorage) {
            setValue({ value: updatedInitialValue });
        }
    }, [updatedInitialValue]);
    // Set value from the
    // root method call:
    useUpdate(() => {
        if (fieldsToBeSet[fieldId] !== undefined) {
            setDirty();
            setValue({ value: fieldsToBeSet[fieldId] });
            setFieldsValue({ [fieldId]: undefined });
        }
    }, [fieldsToBeSet]);
    useUpdate(() => {
        if (!isBuiltDisabled) {
            triggerValidation();
        }
    }, [isBuiltDisabled]);
    // Update the errors from the
    // root method call:
    useUpdate(() => {
        if (injectedErrors[fieldId] !== undefined) {
            const hasErrors = Boolean(injectedErrors[fieldId].errors.length);
            setState((current) => ({
                ...current,
                //@ts-expect-error -- WIP
                errors: injectedErrors[fieldId].override
                    ? //@ts-expect-error -- WIP
                        [...injectedErrors[fieldId].errors]
                    : //@ts-expect-error -- WIP
                        [...current.errors, ...injectedErrors[fieldId].errors],
                isTouched: hasErrors,
                isValid: !hasErrors,
            }));
        }
    }, [injectedErrors]);
    return {
        blur,
        focus,
        resetState,
        setTouch,
        setValidity,
        setValue,
        state,
        triggerValidation,
        updatedDependency,
        updatedInitialValue,
    };
};
_react_refresh_temp_1(useFieldState, "xjTZIr/MrXJt+J/WPppIugz5QF4=", false, () => [useFormRoot, useMemoExtended, useUpdatedRef, useUpdatedRef, useMemoExtended, useBeforeFirstRender, useIsMounted, 
    // Sync with storage or with
    // the internal state on
    // dependency update:
    useUpdate, useUpdate, 
    // Set value from the
    // root method call:
    useUpdate, useUpdate, 
    // Update the errors from the
    // root method call:
    useUpdate]);
